import { render, staticRenderFns } from "./ClientAddress.vue?vue&type=template&id=a2f3a542&scoped=true&"
import script from "./ClientAddress.vue?vue&type=script&lang=js&"
export * from "./ClientAddress.vue?vue&type=script&lang=js&"
import style0 from "./ClientAddress.vue?vue&type=style&index=0&id=a2f3a542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f3a542",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2f3a542')) {
      api.createRecord('a2f3a542', component.options)
    } else {
      api.reload('a2f3a542', component.options)
    }
    module.hot.accept("./ClientAddress.vue?vue&type=template&id=a2f3a542&scoped=true&", function () {
      api.rerender('a2f3a542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/ClientAddress.vue"
export default component.exports